import Landing from "@/views/public/landing";
import SignUp from "@/views/public/signup/Signup";
import EmailVerification from "@/views/public/EmailVerification";
import UpdatePassword from "@/views/public/UpdatePassword";

export default [
  {
    path: "/",
    name: "Landing",
    component: Landing,
    meta: {
      layout: "landing",
    },
  },
  {
    path: "/verify-email",
    name: "Email verification",
    component: EmailVerification,
    meta: {
      layout: "landing",
    },
  },
  {
    path: "/update-password",
    name: "Update password",
    component: UpdatePassword,
    meta: {
      layout: "landing",
    },
  },
  {
    path: "/signup",
    name: "Sign up",
    component: SignUp,
    meta: {
      layout: 'signup'
    }
  },
];
